import $ from 'jquery';

const MAX_COLLAPSIBLE_CONTENT_LENGTH = 15;

class CollapsibleContent extends HTMLElement {
    constructor() {
        super();
        this.isCollapsed = true;
        this.toggleContent = this.toggleContent.bind(this);
    }

    connectedCallback() {
        this.maxLength = parseInt(this.getAttribute('max-length')) || MAX_COLLAPSIBLE_CONTENT_LENGTH;
        this.moreText = this.getAttribute('more-text') || 'Zobraziť viac';
        this.lessText = this.getAttribute('less-text') || 'Zobraziť menej';
        this.mobileOnly = this.hasAttribute('mobile-only');

        this.originalContent = this.innerHTML;
        this.render();

        this.querySelector('button').addEventListener('click', this.toggleContent);
    }

    toggleContent() {
        this.isCollapsed = !this.isCollapsed;
        this.updateContent();

        if (this.isCollapsed){
            this.scrollToContent();
        }
    }

    scrollToContent(){
        const contentElement = this.querySelector('.collapsible-content__content');
        if (contentElement) {
            const yOffset = -80;
            const yPosition = contentElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: yPosition, behavior: 'smooth' });
        }
    }

    render() {
        this.innerHTML = `
            <div class="collapsible-content ${this.isCollapsed ? 'collapsed' : 'expanded'} ${this.mobileOnly ? 'mobile-only' : ''}">
                <div class="collapsible-content__content">
                    ${this.originalContent}
                    <div class="collapsible-content__overlay"></div>
                </div>
                <button class="collapsible-content__button c-btn c-btn--ghost">
                    ${this.isCollapsed ? this.moreText : this.lessText}
                </button>
            </div>
        `;
        this.updateContent();
    }

    updateContent() {
        const $contentElement = $(this.querySelector('.collapsible-content__content'));
        const $buttonElement = $(this.querySelector('.collapsible-content__button'));
        const $collapsibleContentElement = $(this.querySelector('.collapsible-content'));

        if (this.isCollapsed) {
            $collapsibleContentElement.removeClass('expanded');
            $buttonElement.text(this.moreText);
            $contentElement.css('max-height', `${this.maxLength}em`);
        } else {
            $collapsibleContentElement.addClass('expanded');
            $buttonElement.text(this.lessText);
            $contentElement.css('max-height', $contentElement[0].scrollHeight + 'px');
        }
    }
}

customElements.define('collapsible-content', CollapsibleContent);

export default CollapsibleContent;